import ScreenContainer from '../display/ui/ScreenContainer';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import { getGA } from 'analytics/GoogleAnalytics';
import Curtain from '../display/ui/Curtain';
import IntroPlayer from '../display/ui/IntroPlayer';

export default class extends Phaser.State {
  init() {}

  preload() {
    // nothing to load
  }

  create() {
    // store everything in a container, we will reposition this for screen
    this.container = new ScreenContainer(this.game);

    this.intro = new IntroPlayer(this.game, this.game.controller.introDisplayed);
    this.intro.x = this.game.defaultWidth * 0.5;
    this.intro.y = this.game.defaultHeight * 0.5;
    this.container.addChild(this.intro);

    this.logo = this.game.make.image(this.game.defaultWidth * 0.5, 160, 'logo_game');
    this.logo.anchor.set(0.5);
    this.container.addChild(this.logo);
    this.logo.visible = false;

    // start button
    this.btnStart = new ButtonSimple({
      game: this.game,
      up: 'btn_start',
      over: 'btn_start',
    });

    this.btnStart.position.set(this.game.defaultWidth * 0.5, 425);
    this.btnStart.onInputUp.add(this.handleBtnStart, this);
    this.container.addChild(this.btnStart);
    this.btnStart.visible = false;

    // this add curtain
    this.curtain = new Curtain(
      this.game,
      this.game.defaultWidth * 0.5,
      this.game.defaultHeight * 0.5
    );
    this.container.addChild(this.curtain);
    this.curtain.onComplete.addOnce(this.handleCurtainComplete, this);

    // play music
    this.game.sounds.setBackgroundMusic('music_title', true);
    this.game.sounds.playBackgroundMusic();

    // if not first time hide curtain and display idle intro anim
    if (this.game.controller.introDisplayed) {
      this.handleCurtainComplete();
    }
  }

  handleCurtainComplete() {
    this.curtain.visible = false;

    // show logo
    this.logo.visible = true;
    this.logo.scale.set(0);
    this.game.add.tween(this.logo.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Back.Out, true, 100);

    // show start button
    this.btnStart.visible = true;
    this.btnStart.scale.set(0);
    this.game.add
      .tween(this.btnStart.scale)
      .to({ x: 1, y: 1 }, 500, Phaser.Easing.Back.Out, true, 200);

    // play intro
    this.intro.playAnim();
    this.game.controller.introDisplayed = true;

    //
    this.game.sounds.checkAudioContext();
  }

  handleBtnStart() {
    getGA().track({ action: 'clickPlay' });
    this.btnStart.onInputUp.remove(this.handleBtnStart, this);
    this.game.controller.startGame();
  }

  shutdown() {
    this.game.sounds.stopBackgroundMusic();
    this.game.sounds.clearBackgroundMusic();

    // destroy
    this.container.destroy(true);

    // clear up
    this.container = null;
  }
}
